import { Modal } from 'antd'
import cn from 'classnames'
import { ReactComponent as Close24 } from 'assets/svg/Close24.svg'
import { ModalProps } from './types'
import './popup.default.scss'

const Terms = ({
  children,
  className,
  wrapClassName,
  closable = true,
  ...props
}: ModalProps) => (
  <Modal
    closeIcon={<Close24 />}
    closable={closable}
    getContainer="#root"
    className={cn('popup-default terms-popup', className, {
      'popup-default--closable': closable
    })}
    wrapClassName={cn('popup-default-wrap', wrapClassName)}
    destroyOnClose
    centered
    {...props}
  >
    {children}
  </Modal>
)

export default Terms
